export class InvoicePaymentUpdateIncludedInFireBatchDto {
  markInclude: boolean;
  paymentIds: string;
  refundPaymentIds?: string;  
}
